/** @format */

import React from 'react';

function SectionWrapper({ children }) {
  return <div>{children}</div>;
}

export default SectionWrapper;
